module.exports = __webpack_public_path__ + "img/GMC.a462c63b.svg";